import { Button } from '../../../../components/form/button';
import { Typography } from '../../../../components/typography/typography';
import Icon from '../../../../components/icons/icon';
import { Dropdown } from '../../../../components/dropdown/dropdown';
import React from 'react';
import { Order } from '../../../../clients/quipli-service/order/order';
import { useAdmin } from '../../../../hooks/use-admin-context';

export const DownloadMenu = ({ order }: { order: Order }) => {
  const { contextPath } = useAdmin();

  return (
    <Dropdown
      placement="bottom-end"
      dataCy="download-menu"
      trigger={() => (
        <Button className="button button-secondary" data-cy={`download_menu`}>
          <Typography type="text-sm" weight="semi-bold" className="text-[var(--grey-700)] hidden md:inline">
            Download
          </Typography>

          <div className="inline md:hidden">
            <Icon icon="Download" />
          </div>

          <Icon icon="ChevronDown" />
        </Button>
      )}
    >
      {!order.isCycleBilled && order.invoices.length == 0 && (
        <div
          className="min-w-full flex justify-start items-center gap-2 px-0 hover:bg-[var(--grey-100)]"
          onClick={() => {
            window.open(`${contextPath}legacy-app/manager/orders/invoice?orders=${order.id}`);
          }}
        >
          <Typography
            className="flex justify-center justify-items-center gap-1 text-[var(--quipli-black-800)]"
            type="text-sm"
          >
            Invoice
          </Typography>
        </div>
      )}

      <div
        className="min-w-full flex justify-start items-center gap-2 px-0 hover:bg-[var(--grey-100)]"
        onClick={() => {
          window.open(`${contextPath}legacy-app/manager/orders/contract_rental_policy/${order.id}/unsigned`);
        }}
      >
        <Typography
          className="flex justify-center justify-items-center gap-1 text-[var(--quipli-black-800)]"
          type="text-sm"
        >
          Sign in person
        </Typography>
      </div>

      {order.isCycleBilled || (order && order.invoices.length > 0) ? (
        <>
          <div
            className="min-w-full flex justify-start items-center gap-2 px-0 hover:bg-[var(--grey-100)]"
            onClick={() => {
              window.open(`${contextPath}quipli-service/yorent/v2/orders/${order.id}/contract`);
            }}
          >
            <Typography
              className="flex justify-center justify-items-center gap-1 text-[var(--quipli-black-800)]"
              type="text-sm"
            >
              Contract
            </Typography>
          </div>

          {order.signature && (
            <div
              className="min-w-full flex justify-start items-center gap-2 px-0 hover:bg-[var(--grey-100)]"
              onClick={() => {
                window.open(`${contextPath}legacy-app/manager/orders/contract_rental_policy/${order.id}/signed`);
              }}
            >
              <Typography
                className="flex justify-center justify-items-center gap-1 text-[var(--quipli-black-800)]"
                type="text-sm"
              >
                Signed Contract
              </Typography>
            </div>
          )}
        </>
      ) : (
        <div
          className="min-w-full flex justify-start items-center gap-2 px-0 hover:bg-[var(--grey-100)]"
          onClick={() => {
            window.open(`${contextPath}legacy-app/manager/orders/invoice/${order.id}`);
          }}
        >
          <Typography
            className="flex justify-center justify-items-center gap-1 text-[var(--quipli-black-800)]"
            type="text-sm"
          >
            E-Signature
          </Typography>
        </div>
      )}
    </Dropdown>
  );
};
